module.exports = __webpack_public_path__ + "media/PAG65-04.40e8fd7a.mp3";